var err_msg_min = '<h6>Error at checkout</h6>It looks like you have not added a piece of vintage jewelry yet. To take advantage of this offer, you need to add at least one piece of jewelry to your cart. Thanks!';
$(function() {

  $('#fancy_alert').on('click', function() {
      $.fancybox(
        {
			'overlayColor' : '#000',
			'overlayOpacity' : 0.5 ,
			'content': err_msg_min,
			'maxWidth'	: 800,
			'maxHeight'	: 600,
			'fitToView'	: false,
			'width'		: '70%',
			'height'		: 'auto',
			'autoSize'	: false,
			'closeClick'	: false,
			'openEffect'	: 'none',
			'closeEffect'	: 'none'
      });
  });
  
  $('.fancy_alertc').on('click', function() {
      $.fancybox(
        {
			'overlayColor' : '#000',
			'overlayOpacity' : 0.5 ,
			'content': err_msg_min,
			'maxWidth'	: 800,
			'maxHeight'	: 600,
			'fitToView'	: false,
			'width'		: '70%',
			'height'		: 'auto',
			'autoSize'	: false,
			'closeClick'	: false,
			'openEffect'	: 'none',
			'closeEffect'	: 'none'
      });
  });
  
  $('#hid_fil').click(function() {
  var tog = $(this);
  var tog2 = $('#hid_fil2');
  tog2.parent().find('.main').toggleClass('hide');
  //$('.first > .main').toggleClass('hide');
    tog.toggleClass('fa fa-chevron-up fa fa-chevron-down');
    $(this).find('#tex_fil').html(function(i, text){
      return text === 'Hide Filters' ? 'Show Filters' : 'Hide Filters';
    });
     return false;
    //alert('works');
  });
  
  var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : false;
  $(document).ready(function() {
    if(!isMobile) {
      $( "#desk360" ).addClass( "show360" );
      $( "#mobi360" ).addClass( "hid360-2" );
    }else{
      $( "#mobi360" ).addClass( "show360" );
      $( "#desk360" ).addClass( "hid360" );
    };
  });
  
  $(document).ready(function(e){
    $('.cntl').cntl({
      // The amount of "scroll padding" to allow 
      // The more, the later the state will be revealed
      revealbefore: 300,
      // The animate class
      // This class should have animation rules in css
      anim_class: 'cntl-animate',
      // A callback once the state has been revealed
      onreveal: null
	 });
  });
  
  var acc = document.getElementsByClassName("accordion");
  var i;
  for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight){
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    }
  }
})